<template>
  <div class="age-check-failed-container">
    <div class="logo-container">
      <img :src="logo" alt="logo" class="logo" />
    </div>
    <div class="lower-container">
      <div class="failed-header">
        {{ $t("age_check_failed.failed_header") }}
      </div>
      <div class="failed-content">
        {{ $t("age_check_failed.failed_content") }}
      </div>
      <div class="close-button-container">
        <button type="button" class="close-button" @click="handleButtonClick">
          GOT IT
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logo_jaegermeister_white.svg";
import close from "@/assets/images/close.svg";
export default {
  data() {
    return {
      logo: logo,
      close: close,
    };
  },
  methods: {
    handleButtonClick() {
      this.$store.state.sounds.tapSound.play();
      location.reload();
    },
  },
};
</script>

<style scoped>
.age-check-failed-container {
  text-align: center;
  color: white;
  display: flex;
  flex-direction: column;
  font-family: "Meister-Regular";
  justify-content: space-between;
  margin-top: 6rem;
  align-items: center;
  height: 75dvh;
}

.logo-container {
  margin-bottom: 1rem;
}

.logo {
  width: 100px;
  margin-top: 4rem;
}

.failed-header {
  font-family: "Meister-Bold";
  font-size: 3.6rem;
  line-height: 1;
  margin-bottom: 1rem;
}

/* .failed-subheader {
  font-weight: bold;
  font-size: 4rem;
  line-height: 1;
  margin: 1rem 0;
} */

.failed-content {
  padding: 0 4.25rem;
  font-size: 1.75rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-weight: 300;
}

.close-button-container {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

.close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Meister-Bold";
  color: black;
  --tw-bg-opacity: 1;
  background-color: white;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  width: 30rem;
  border: none;
  cursor: pointer;
  border-radius: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  margin-right: 1rem;
  margin-left: 1rem;
}

.close-icon {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

.lower-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  width: 100%;
}
</style>
